<template>
  <div class="col-12">
    <BarChart :height="630" :chartData="testData" :options="options" />
  </div>
</template>

<script>
import { defineComponent, computed, ref } from "vue";
import { BarChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(...registerables);
Chart.register(ChartDataLabels);

export default defineComponent({
  components: { BarChart },
  props: ["titulo", "labels", "datasets"],
  setup(props) {
    const testData = computed(() => ({
      labels: props.labels,
      datasets: props.datasets,
    }));

    const options = ref({
      responsive: true,
      plugins: {
        datalabels: {
          color: "white",
        },
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: props.titulo,
          fontSize: 19,
        },
        pieceLabel: {
          render: "value",
          precision: 1,
        },
        showAllTooltips: true,
      },
    });

    return { testData, options };
  },
});
</script>
